/* eslint-disable no-nested-ternary */

import { VStack, Text } from '@chakra-ui/react';
import Link from 'next/link';

import * as paths from 'lib/constants/paths';
import Button from 'components/atoms/button';

export interface EmptyListProps {
  international?: boolean;
  isCandidateAuthenticated: boolean;
}

export const EmptyList = ({ isCandidateAuthenticated }: EmptyListProps) => (
  <VStack mt={90} spacing={5}>
    <Text
      textAlign='center'
      fontSize={['xl', 'xl', '3xl']}
      maxWidth={[270, 270, 400]}
    >
      Não encontramos vagas para a sua busca 😕
    </Text>
    <Text textAlign='center' fontSize='sm' maxWidth={[280, 280, 450]}>
      {isCandidateAuthenticated
        ? 'Tente uma nova uma busca para encontrar mais oportunidades.'
        : 'Tente uma nova uma busca para encontrar mais oportunidades. Aproveite para criar o seu perfil e fique por dentro das dezenas de novas oportunidades que, todos os dias, surgem por aqui.'}
    </Text>
    {!isCandidateAuthenticated ? (
      <Link href={paths.CANDIDATE_LP} passHref>
        <Button mt={30}>Criar meu perfil</Button>
      </Link>
    ) : null}
  </VStack>
);
